import { render, staticRenderFns } from "./paginate.vue?vue&type=template&id=31af7938&scoped=true&"
import script from "./paginate.vue?vue&type=script&lang=js&"
export * from "./paginate.vue?vue&type=script&lang=js&"
import style0 from "./paginate.vue?vue&type=style&index=0&id=31af7938&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af7938",
  null
  
)

export default component.exports